/**
 * Phân quyền báo cáo — FE mirror auth `banHangWebMenu`.
 * Mỗi báo cáo: Xem danh sách (dự án đang đứng) · Xem toàn hệ thống (mọi mảng) · Giá vốn (và % lợi nhuận).
 * `WEB_BH_BAO_CAO_TONG_HOP` xem được trang tổng hợp.
 */

export const BAO_CAO_PERMISSION_CODES = {
  WEB_BH_BAO_CAO_TONG_HOP: 'WEB_BH_BAO_CAO_TONG_HOP',
  WEB_BH_BAO_CAO_DOANH_THU_LN: 'WEB_BH_BAO_CAO_DOANH_THU_LN',
  WEB_BH_BAO_CAO_TON_KHO: 'WEB_BH_BAO_CAO_TON_KHO',
  WEB_BH_BAO_CAO_TOP_SALE: 'WEB_BH_BAO_CAO_TOP_SALE',
  WEB_BH_BAO_CAO_TOP_MUA: 'WEB_BH_BAO_CAO_TOP_MUA',
  WEB_BH_BAO_CAO_DA_LUU: 'WEB_BH_BAO_CAO_DA_LUU',
} as const

export type BaoCaoPermissionCode =
  (typeof BAO_CAO_PERMISSION_CODES)[keyof typeof BAO_CAO_PERMISSION_CODES]

/** Map `BaoCaoLoai` → mã quyền xem. */
export const BAO_CAO_LOAI_PERMISSION: Record<string, BaoCaoPermissionCode> = {
  'doanh-thu-ln': BAO_CAO_PERMISSION_CODES.WEB_BH_BAO_CAO_DOANH_THU_LN,
  'ton-kho': BAO_CAO_PERMISSION_CODES.WEB_BH_BAO_CAO_TON_KHO,
  'top-sale': BAO_CAO_PERMISSION_CODES.WEB_BH_BAO_CAO_TOP_SALE,
  'top-mua': BAO_CAO_PERMISSION_CODES.WEB_BH_BAO_CAO_TOP_MUA,
}

/** Map `BaoCaoLoai` → mã quyền phụ: xem mọi mảng, xem giá vốn / lợi nhuận. */
export const BAO_CAO_LOAI_QUYEN_PHU: Record<string, { toanHeThong: string; giaVon: string }> = {
  'doanh-thu-ln': {
    toanHeThong: 'WEB_BH_BAO_CAO_DOANH_THU_LN_TOAN_HE_THONG',
    giaVon: 'WEB_BH_BAO_CAO_DOANH_THU_LN_GIA_VON',
  },
  'ton-kho': {
    toanHeThong: 'WEB_BH_BAO_CAO_TON_KHO_TOAN_HE_THONG',
    giaVon: 'WEB_BH_BAO_CAO_TON_KHO_GIA_VON',
  },
  'top-sale': {
    toanHeThong: 'WEB_BH_BAO_CAO_TOP_SALE_TOAN_HE_THONG',
    giaVon: 'WEB_BH_BAO_CAO_TOP_SALE_GIA_VON',
  },
  'top-mua': {
    toanHeThong: 'WEB_BH_BAO_CAO_TOP_MUA_TOAN_HE_THONG',
    giaVon: 'WEB_BH_BAO_CAO_TOP_MUA_GIA_VON',
  },
}

/** Mọi mã báo cáo — dùng `hasAny` để mở route `/bao-cao`. */
export const BAO_CAO_ANY_VIEW_PERMISSIONS = Object.values(BAO_CAO_PERMISSION_CODES)
